import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyModule } from '../../../../directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { SelectedQuestionnaireComponent } from './selected-questionnaire.component';
import { BannerModule, ButtonModule, TagsModule } from '@xref/xref-lib';

@NgModule({
  declarations: [
    SelectedQuestionnaireComponent
  ],
  imports: [
    CommonModule,
    TooltipEllipsifyModule,
    TooltipModule.forRoot(),
    BannerModule,
    ButtonModule,
    TagsModule,
  ],
  exports: [ SelectedQuestionnaireComponent ],
})
export class SelectedQuestionnaireModule {
}
